import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";

import {
  SedsBasicButtonModule,
  SedsFlatButtonModule,
  SedsLoadersSpinnerModule,
  SedsModalModule,
  SedsRadioButtonModule,
} from "experian-design-system"; // NOSONAR

import { GuidedTourModule, GuidedTourService } from "ngx-guided-tour";
import { ActionFooterComponent } from "./components/action-footer/action-footer.component";
import { AlertModule } from "./components/alert/alert.module";
import { FooterModule } from "./components/footer/footer.module";
import { RecertificationConfirmationComponent } from "./components/recertification-confirmation/recertification-confirmation.component";
import { FakeDataTableComponent } from "./components/virtual-tour/sub-components/fake-data-table/fake-data-table.component";
import { ModalTourComponent } from "./components/virtual-tour/sub-components/modal-tour/modal-tour.component";
import { VirtualTourComponent } from "./components/virtual-tour/virtual-tour.component";
import { AnalyticsButtonDirective } from "./directives/analytics-button.directive";
import { MaterialModule } from "./material.module";
import { DocumentPipe } from "./pipes/document.pipe";
import { PhonePipe } from "./pipes/phone.pipe";

@NgModule({
  declarations: [
    ActionFooterComponent,
    AnalyticsButtonDirective,
    DocumentPipe,
    FakeDataTableComponent,
    ModalTourComponent,
    PhonePipe,
    RecertificationConfirmationComponent,
    VirtualTourComponent,
  ],
  imports: [
    AlertModule,
    CommonModule,
    FooterModule,
    GuidedTourModule,
    MaterialModule,
    SedsModalModule,
    SedsBasicButtonModule,
    SedsFlatButtonModule,
    SedsRadioButtonModule,
    SedsLoadersSpinnerModule,
  ],
  exports: [
    ActionFooterComponent,
    AlertModule,
    AnalyticsButtonDirective,
    DocumentPipe,
    FakeDataTableComponent,
    FooterModule,
    MaterialModule,
    ModalTourComponent,
    PhonePipe,
    RecertificationConfirmationComponent,
    SedsBasicButtonModule,
    SedsFlatButtonModule,
    VirtualTourComponent,
  ],
  providers: [GuidedTourService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
